/**
 * Centralized logging utility
 * Controls logging based on environment variables
 */

// Check if debug logging is enabled
const isDebugEnabled = () => {
  return (
    process.env.REACT_APP_DEBUG_LOGGING === "true" ||
    process.env.NODE_ENV === "development"
  );
};

// Check if auth debug logging is specifically enabled
const isAuthDebugEnabled = () => {
  return (
    process.env.REACT_APP_AUTH_DEBUG === "true" ||
    (process.env.NODE_ENV === "development" &&
      process.env.REACT_APP_AUTH_DEBUG !== "false")
  );
};

class Logger {
  static log(...args) {
    if (isDebugEnabled()) {
      console.log(...args);
    }
  }

  static warn(...args) {
    if (isDebugEnabled()) {
      console.warn(...args);
    }
  }

  static error(...args) {
    // Always log errors, regardless of debug setting
    console.error(...args);
  }

  static debug(...args) {
    if (isDebugEnabled()) {
      console.log("[DEBUG]", ...args);
    }
  }

  // Specific auth logging
  static authLog(...args) {
    if (isAuthDebugEnabled()) {
      console.log("[AUTH]", ...args);
    }
  }

  static authWarn(...args) {
    if (isAuthDebugEnabled()) {
      console.warn("[AUTH]", ...args);
    }
  }

  static authError(...args) {
    // Always log auth errors
    console.error("[AUTH ERROR]", ...args);
  }

  // Organization specific logging
  static orgLog(...args) {
    if (isDebugEnabled()) {
      console.log("[ORG]", ...args);
    }
  }

  // User specific logging
  static userLog(...args) {
    if (isDebugEnabled()) {
      console.log("[USER]", ...args);
    }
  }
}

export default Logger;
